import { useState } from "react";

import { Licenses } from "common/components/subscriptions";
import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function ReactivateSubscriptionButton() {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant="default-purple"
        size={isDesktop ? "sm" : "lg"}
        onClick={() => setIsOpen(true)}
      >
        Reactivate subscription
      </Button>

      <Licenses isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
}
